<template>
  <div class="site_lease">
    <van-sticky>
      <van-nav-bar title="立即租赁" left-arrow @click-left="goback()" />
    </van-sticky>
    <CardBuilding :detailData="detailData"></CardBuilding>
    <div class="lease_title">签约主体信息</div>
    <!-- 表单 -->
    <van-form label-width="160" class="lease_form" :show-error="false" @submit="onSubmit" error-message-align="right">
      <van-cell-group>
        <van-field input-align="right" required label="姓名" v-model="submitData.contactName" placeholder="请输入" :rules="[{ required: true, message: '请输入姓名' }]" />
        <van-field input-align="right" required label="手机号" v-model="submitData.contactNumber" placeholder="请输入" :rules="[
          { required: true, message: '请输入手机号' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机格式错误！' },
        ]" />
        <van-field input-align="right"  v-model="submitData.intermediary_company" label="中介公司名" placeholder="请输入" />
        <van-field input-align="right"  v-model="submitData.company" label="预注册公司名称" placeholder="请输入" />
        <div class="form_feature">
          <div class="fs14">场地用途</div>
          <div class="feature_list">
            <van-button native-type="button" :color="item.isCheck ? '#0CADFC' : '#DFDDDD'" v-for="(item, index) in siteUseList" :key="item.itemId" @click="changeSiteOpentions(index)">{{
              item.itemText
              }}</van-button>
          </div>
        </div>
        <div class="form_feature">
          <div class="fs14">请勾选设置可租赁的套餐时长</div>
          <div class="feature_list">
            <van-button native-type="button" :color="item1.isCheck ? '#0CADFC' : '#DFDDDD'" v-for="(item1, index1) in leaseDurationList" :key="item1.itemId" @click="changeLeaseDurationList(index1)">
              {{ item1.itemText }}</van-button>
          </div>
        </div>
        <div class="lease_title">备注</div>
        <van-field v-model="submitData.remark" rows="2" autosize type="textarea" maxlength="200" placeholder="请检单描述你的需求" show-word-limit />
        <div class="form_activity" v-if="couponList.length > 0" @click="showList = true">
          <div class="fs13 font-weightbold">领取优惠券</div>
          <div class="flex-row jc_between">
            <van-tag v-if="submitData.coupon_id != 0" type="danger">{{
              submitData.coupon_name
              }}</van-tag>
            <van-tag v-else>有可用优惠券</van-tag>
            <van-icon name="weapp-nav" size="25" />
          </div>
        </div>
        <!-- 优惠券列表 -->
        <van-popup v-model="showList" round position="bottom" style="height: 50%; padding-top: 4px">
          <div class="coupon_list" v-for="(ktems, indexs) in couponList" :key="ktems.id">
            <div class="list_item">
              <div class="item">
                <div class="item_name line2">
                  {{ ktems.name }}
                </div>
                <span>￥{{ ktems.price_reduce }}元优惠</span>
              </div>
              <div style="color: #ff6d58">满￥{{ ktems.price_full }}元使用</div>
              <div>有效期{{ ktems.beginDate }}至{{ ktems.endDate }}</div>
            </div>
            <div class="list_price">
              <span @click="userCouponList(ktems.id, indexs)">使用</span>
            </div>
          </div>
        </van-popup>
        <div class="form_feature">
          <div class="fs14 font-weightbold">增值服务（以下服务不参与营销）</div>
          <div class="feature_server" v-for="(itemss, indexss) in extra" :key="itemss">
            <div>{{ itemss.name }}:</div>
            <div class="server_btn">
              <van-button native-type="button" @click="changeExtra(indexss)" :color="itemss.isCheck ? '#0CADFC' : ''">
                不需要</van-button>
              <van-button native-type="button" @click="changeExtra(indexss)" :color="itemss.isCheck ? '' : '#0CADFC'">需要
              </van-button>
            </div>
          </div>
        </div>
        <!-- {{couponIndex != -1 ? couponList[couponIndex].price_reduce : "0" }} -->
        <van-submit-bar button-text="立即付款" button-color="#0CADFC">
          <div class="fs15">
            价格
            <span class="fs14 color999">
              {{ orderPayPriceInfo.payablePrice }}元/月 (优惠￥{{orderPayPriceInfo.discountAmount}})
            </span>
          </div>
        </van-submit-bar>
      </van-cell-group>
    </van-form>
  </div>
</template>
<script>
import CardBuilding from "./components/CardBuilding";
import {
  Button,
  NavBar,
  Icon,
  Sticky,
  Image,
  Form,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  SubmitBar,
  Tag,
  CouponCell,
  CouponList,
  Popup,
  Dialog,
} from "vant";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [SubmitBar.name]: SubmitBar,
    [Tag.name]: Tag,
    [CouponCell.name]: CouponCell,
    [CouponList.name]: CouponList,
    [Popup.name]: Popup,
    CardBuilding,
  },
  data() {
    return {
      submitData: {
        site_id: 0,
        coupon_id: 0,
        contactName: "",
        contactNumber: "",
        intermediary_company: "",
        company: "",
        siteUse: "",
        leaseDuration: "1",
        remark: "",
        else_registered: "0",
        else_seal: "0",
        else_bankAccount: "0",
        else_taxBureauRegistration: "0",
        else_annualAudit: "0",
        else_accountOpeningAppointment: "0",
        else_taxBureauDoorToDoorAppointment: "0",
      },
      extra: [
        { name: "工商注册", isCheck: true },
        { name: "刻章服务", isCheck: true },
        { name: "银行开户", isCheck: true },
        { name: "税局登记", isCheck: true },
        { name: "年审服务", isCheck: true },
        { name: "开户预约", isCheck: true },
        { name: "税局上门预约", isCheck: true },
      ],
      params: {
        site_id: 0,
        coupon_id: 0,
        leaseDuration: 0,
        else_registered: 0,
        else_seal: 0,
        else_bankAccount: 0,
        else_taxBureauRegistration: 0,
        else_annualAudit: 0,
        else_accountOpeningAppointment: 0,
        else_taxBureauDoorToDoorAppointment: 0,
      },
      detailData: [],
      siteUseList: [], //场地特色
      leaseDurationList: [], //租赁时长
      couponList: [],
      couponIndex: -1,
      showList: false,
      totalPrice: 0,
      orderPayPriceInfo:{
        totalPrice: 0,
        payablePrice: 0,
        discountAmount: 0,
      }
    };
  },

  created() {
    this.submitData.site_id = this.$route.query.id;
    this.params.site_id = this.$route.query.id;
    // 个人信息
    this.changePortraitDetail();
    //场地中心-查看
    this.siteUserH5Detail(this.$route.query.id);
  },

  methods: {
    //个人信息-查看
    changePortraitDetail() {
      var that = this;
      that.$api
        .changePortraitDetailAPI(that.params)
        .then(function(res) {
          if (res.data.code === 200) {
            that.submitData.contactName = res.data.data.fullName
            that.submitData.contactNumber = res.data.data.contactNumber
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },
    changeExtra(index) {
      var that = this;
      that.extra[index].isCheck = !that.extra[index].isCheck;
      switch (index) {
        case 0:
          that.params.else_registered = that.extra[index].isCheck ? 0 : 1;
          //订单-计算应付金额
          that.calcOrderTotalPrice();
          break;
        case 1:
          that.params.else_seal = that.extra[index].isCheck ? 0 : 1;
          that.calcOrderTotalPrice();
          break;
        case 2:
          that.params.else_bankAccount = that.extra[index].isCheck ? 0 : 1;
          that.calcOrderTotalPrice();
          break;
        case 3:
          that.params.else_taxBureauRegistration = that.extra[index].isCheck ? 0 : 1;
          that.calcOrderTotalPrice();
          break;
        case 4:
          that.params.else_annualAudit = that.extra[index].isCheck ? 0 : 1;
          that.calcOrderTotalPrice();
          break;
        case 5:
          that.params.else_accountOpeningAppointment =
            that.extra[index].isCheck ? 0 : 1;
          that.calcOrderTotalPrice();
          break;
        default:
          that.params.else_taxBureauDoorToDoorAppointment =
            that.extra[index].isCheck ? 0 : 1;
          that.calcOrderTotalPrice();
          break;
      }
    },

    //选中场地特色
    changeSiteOpentions(index) {
      this.siteUseList.forEach((element, item) => {
        if (index === item) {
          element.isCheck = true;
          this.submitData.siteUse = item.itemId;
        } else {
          element.isCheck = false;
        }
      });
    },

    //租赁时长
    changeLeaseDurationList(index) {
      this.leaseDurationList.forEach((element, item) => {
        if (index === item) {
          element.isCheck = true;
          this.submitData.leaseDuration = element.itemId;
          this.params.leaseDuration = element.itemId;
          console.log("leaseDuration", this.params.leaseDuration, element.itemId)
          //订单-计算应付金额
          this.calcOrderTotalPrice();
        } else {
          element.isCheck = false;
        }
      });
    },

    //订单-计算应付金额
    calcOrderTotalPrice() {
      var that = this;
      that.$api
        .calcOrderTotalPriceAPI(that.params)
        .then(function(res) {
          if (res.data.code === 200) {
            that.totalPrice = res.data.data.totalPrice;
            that.orderPayPriceInfo = res.data.data;
          }
        })
        .catch(function(err) {
          console.log("error", err);
        });
    },

    userCouponList(id, index) {
      this.showList = false;
      if(this.couponList[index].price_full > this.totalPrice){
        Dialog.alert({
              title: '提示',
              message: '当前价格不满足满减优惠',
            }).then(() => {
              // on close
            });
        return false;
      }
      this.submitData.coupon_name =
        "满" +
        this.couponList[index].price_full +
        "减" +
        this.couponList[index].price_reduce;
      this.submitData.coupon_id = id;
      this.couponIndex = index;
      this.params.coupon_id = id;
      console.log(index,this.couponList[this.couponIndex].price_reduce)
      this.calcOrderTotalPrice();
    },

    //场地中心-查看
    siteUserH5Detail(id) {
      var that = this;
      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      that.$api
        .orderInfoUserH5AddAPI({ site_id: id })
        .then(function(res) {
          if (res.data.code === 200) {
            that.couponList = res.data.data.couponList;
            //场地特色
            var siteUseList = res.data.data.siteUseList;

            if (siteUseList.length > 0) {
              siteUseList.forEach((element, index) => {
                if (index === 0) {
                  element.isCheck = true;
                  that.submitData.siteUse = element.itemId;
                } else {
                  element.isCheck = false;
                }
              });
            }

            that.siteUseList = siteUseList;
            //租赁时长
            var leaseDurationList = res.data.data.leaseDurationList;
            that.params.leaseDuration = Number(leaseDurationList[0].itemId);
            that.calcOrderTotalPrice();

            if (leaseDurationList.length > 0) {
              leaseDurationList.forEach((element, index) => {
                if (index === 0) {
                  that.submitData.leaseDuration = element.itemId;
                  element.isCheck = true;
                } else {
                  element.isCheck = false;
                }
              });
            }

            that.leaseDurationList = leaseDurationList;
            that.detailData = res.data.data.siteVo;
          }
          that.$Toast.clear();
        })
        .catch(function(err) {
          console.log("error", err);
        });
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    // 员工管理-编辑
    onSubmit() {
      var that = this;
      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      this.submitData.else_registered = this.extra[0].isCheck ? 0 : 1;
      this.submitData.else_seal = this.extra[1].isCheck ? 0 : 1;
      this.submitData.else_bankAccount = this.extra[2].isCheck ? 0 : 1;
      this.submitData.else_taxBureauRegistration = this.extra[3].isCheck ?
        0 :
        1;
      this.submitData.else_annualAudit = this.extra[4].isCheck ? 0 : 1;
      this.submitData.else_accountOpeningAppointment = this.extra[5].isCheck ?
        0 :
        1;
      this.submitData.else_taxBureauDoorToDoorAppointment = this.extra[6]
        .isCheck ?
        0 :
        1;
      this.submitData.siteUse = this.siteUseList[this.siteUseList.findIndex(item => item.isCheck == true)].itemId

      that.$api
        .orderInfoUserH5SaveAPI(that.submitData)
        .then(function(res) {
          if (res.data.code === 200) {
            that.jsapiUnifiedorder(res.data.data);
            that.$Toast.clear();
          } else {
            that.$Toast.clear();
            Dialog.alert({
              title: '提示',
              message: res.data.message,
            }).then(() => {
              // on close
            });
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    jsapiUnifiedorder(id) {
      var that = this;
      that.$api
        .jsapiUnifiedorderAPI({ order_info_id: id })
        .then(function(res) {
          if (res.data.code === 200) {
            if(res.data.data.is_need_pay === "1")
              that.onBridgeReady(res.data.data);
            if(res.data.data.is_need_pay === "0")
              that.$router.push({ path: "/home/playSuccess" });
          } else {
            that.$Notify({
              type: "warning",
              message: res.data.message,
              onClose() {
                if (res.data.message === '抱歉，订单用户尚未绑定微信号')
                  that.$router.push({ path: "/personal/setting" });
              }
            });
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    onBridgeReady(data = "") {
      let that = this;
      if (data == "") return false;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest", {
          appId: data.appId, //公众号ID，由商户传入
          timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, //随机串
          package: data.package,
          signType: data.signType, //微信签名方式：
          paySign: data.paySign, //微信签名
        },
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            /*Dialog.alert({
              title: '提示',
              message: '支付成功',
            }).then(() => {
              // on close
              that.$router.go(-1);
            });*/
            that.$router.push({ path: "/home/playSuccess" });
          } else {
            Dialog.alert({
              title: '提示',
              message: '请及时支付!',
            }).then(() => {
              // on close
              that.$router.go(-1);
            });
          }
        }
      );
    },

  },
};

</script>
<style lang="less" scoped>
.site_lease {
  /deep/.van-submit-bar__button[data-v-35b645fe] {
    border-radius: unset;
    height: 35px;
  }

  .form_feature {
    color: #646566;
    margin: 15px 10px;

    .feature_list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .van-button {
        height: 35px;
        margin-top: 15px;
        padding: 0px 25px;
        margin-left: 10px;
      }
    }

    .feature_server {
      display: flex;
      justify-content: space-between;
      font-size: 15px;
      margin-top: 15px;
      align-items: center;

      .server_btn {
        display: flex;
        justify-content: space-between;

        .van-button {
          width: 100px;
          margin-left: 15px;
          font-size: 12px;
          height: 30px;
        }
      }
    }
  }

  .lease_title {
    font-size: 14px;
    color: #666;
    padding: 15px 20px;
    background: #f4f3f8;
  }

  .van-radio-group {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .van-button {
    height: 25px;
  }

  .van-submit-bar__bar {
    justify-content: space-between;
  }

  .van-submit-bar__button {
    border-radius: unset;
  }

  .lease_form {
    .form_activity {
      display: flex;
      padding: 0px 10px;
      margin-top: 25px;
      justify-content: space-between;
      align-items: center;

      .flex-row {
        width: 280px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}

.coupon_list {
  margin: auto;
  background-image: url("/static/images/coupon.jpg");
  background-size: 100%;
  /*设置图片大小*/
  background-repeat: no-repeat;
  width: 90%;
  height: 124px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .list_item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 70%;
    width: 200px;
    margin-left: 20px;
    font-size: 13px;
    color: #999;

    .item {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      font-weight: bold;
      color: #000;

      .item_name {
        width: 100px;
      }

      span {
        color: #ff6d58;
      }
    }
  }

  .list_price {
    display: flex;
    flex-direction: column;
    width: 100px;
    border-left: 1px dashed #f1f2f7;
    align-items: center;
    justify-content: flex-end;
    height: 100%;

    .price {
      display: flex;
      align-items: flex-end;
      font-size: 25px;
      color: #ff6d58;
      font-weight: bold;

      span {
        font-size: 12px;
      }
    }

    >span {
      margin-bottom: 15px;
      font-size: 12px;
      background: #ff6d58;
      padding: 4px 10px;
      color: #fff;
      border-radius: 5px;
      margin-top: 8px;
      display: block;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/home/siteLease.vue